<template>
    <div class="songs-list" >
      <div class="songs-list--preview" v-for="meetup in meetups" :key="meetup.id">
        <div class="preview--avatar">  
          <img :src='meetup.imageurl'>
        </div>
        <div class="preview--content">
          <div class="preview-content--info">
            <div class="preview-content-info--name"><div>{{  meetup.name }}</div><span>{{ meetup.age }} років</span></div>
            <div class="preview-content-info--song"><span>пісня:</span>{{ meetup.song }}</div>
            <div class="preview-content-info--category">{{ meetup.category }}</div>
          </div>
          <div class="preview-content--control">
              <app-modal-video :meetupYoutube="meetup.youtube" ></app-modal-video>
              <app-meetup-register-dialog v-if="userIsAuthenticated"
                          :meetupId="meetup.id">
              </app-meetup-register-dialog>
              <app-modal-auth v-else>
              </app-modal-auth>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    computed: {
      meetups () {
        return this.$store.getters.loadedMeetups
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      loading () {
        return this.$store.getters.loading
      }
    }


  }
</script>



// WEBPACK FOOTER //
// src/components/Meetup/Meetups.vue